import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import classes from "./ConsigneeInfo.module.css";
import { useMultiStepForm } from "./MultiStepFormContext";
import { t } from "i18next";
import { countrySupportMap } from "../../constants";

export const ConsentForm = () => {
  const navigate = useNavigate();
  const { providerFormData, setFormData } = useMultiStepForm();

  // Initialize from context state on mount
  const [selectedOption, setSelectedOption] = useState<
    "informUserMyself" | "providePermobilData" | ""
  >("");
  const savedCountry = sessionStorage.getItem("country") ?? "";
  const countriesWithNoDataSubmissionFlow = [
    "KR",
    "TW",
    "HK",
    "CH",
    "BE",
    "DE",
    "DK",
    "ES",
    "FR",
    "UK",
    "IT",
    "NL",
    "NO",
    "SE",
    "GL",
    "SG",
  ];
  const hasProvideDataOption =
    countriesWithNoDataSubmissionFlow.includes(savedCountry);

  const CountryData = countrySupportMap[savedCountry];

  useEffect(() => {
    if (providerFormData.informUserMyself) {
      setSelectedOption("informUserMyself");
    } else if (providerFormData.providePermobilData) {
      setSelectedOption("providePermobilData");
    } else {
      setSelectedOption("");
    }
  }, [providerFormData]);

  const handleProvideDownload = () => {
    const link = document.createElement("a");
    link.href = CountryData.provideUserData ?? "/"; // or '/your-file.xlsx' for Excel
    link.download = "file.xlsx"; // or 'file.xlsx' for Excel
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleHandleUserDownload = () => {
    const link = document.createElement("a");
    link.href = CountryData.handleUserData ?? "/"; // or '/your-file.xlsx' for Excel
    link.download = "file.xlsx"; // or 'file.xlsx' for Excel
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleNext = () => {
    setFormData((prev) => ({
      ...prev,
      informUserMyself: selectedOption === "informUserMyself",
      providePermobilData: selectedOption === "providePermobilData",
    }));
    navigate("/provider-form"); // Update this path if needed
  };
  const handleBack = () => {
    navigate("/consignee?type=provider");
  };

  return (
    <div className={classes.container}>
      <h3>{t("consent.page_title")}</h3>
      <div className={classes.formWrapper}>
        <p className={classes.infoText}>{t("common.mandatory_info_text")}*</p>
        <div className={classes.row}>
          <label className={classes.label}>
            {t("consent.inform_user_myself")}*
          </label>
          <div className={classes.checkboxWrapper}>
            <input
              type="checkbox"
              checked={selectedOption === "informUserMyself"}
              onChange={() =>
                setSelectedOption(
                  selectedOption === "informUserMyself"
                    ? ""
                    : "informUserMyself"
                )
              }
            />
          </div>
        </div>
        {!hasProvideDataOption && (
          <>
            <div className={classes.flexElement}>
              <div className={classes.row}>
                <label className={classes.label}>
                  {t("consent.provide_user_details")}*
                </label>
                <div className={classes.checkboxWrapper}>
                  <input
                    type="checkbox"
                    checked={selectedOption === "providePermobilData"}
                    onChange={() =>
                      setSelectedOption(
                        selectedOption === "providePermobilData"
                          ? ""
                          : "providePermobilData"
                      )
                    }
                  />
                </div>
              </div>
            </div>

            {selectedOption === "informUserMyself" && (
              <div className={classes.imageContainer}>
                <img
                  src="/images/excel.png"
                  alt="Download"
                  className={classes.excelImage}
                  onClick={handleHandleUserDownload}
                  role="button"
                  tabIndex={0}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") handleHandleUserDownload();
                  }}
                />
                <div>{t("consent.inform_user_excel_info")}</div>
                <span>{CountryData.email}</span>
              </div>
            )}
            {selectedOption === "providePermobilData" && (
              <div className={classes.imageContainer}>
                <img
                  src="/images/excel.png"
                  alt="Download"
                  className={classes.excelImage}
                  onClick={handleProvideDownload}
                  role="button"
                  tabIndex={0}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") handleProvideDownload();
                  }}
                />
                <div>{t("consent.inform_permobil_excel_info")}</div>
                <span>{CountryData.email}</span>
              </div>
            )}
          </>
        )}
        <div className={"mandatoryText"}>* {t("common.required")}</div>
        <div className={classes.nextContainer}>
          <button className={classes.backButton} onClick={handleBack}>
            {t("common.back")}
          </button>
          <button
            className={classes.nextButton}
            onClick={handleNext}
            disabled={selectedOption === ""}
          >
            {t("common.next")}
          </button>
        </div>
      </div>
    </div>
  );
};
